const state = {
  consumption: {},
  currentYear: new Date().getFullYear(),
};

const mutations = {
  set(currentState, consumption) {
    currentState.consumption = consumption;
  },
};

export { mutations, state };
